import { useEffect } from 'react';
import { getInAppMessages, initializeWithConfig } from '@iterable/web-sdk';

import MarketingApi from 'apis/supremeGolfApi/MarketingApi';
import Iterable from 'utils/tracking/iterable';

const useInAppMessage = ({ isLoggedIn, id }) => {
  const inAppProperties = {
    count: 10,
    onOpenScreenReaderMessage: '...',
    onOpenNodeToTakeFocus: 'input',
    packageName: `${process.env.REACT_APP_NAME}-${process.env.REACT_APP_ENV}`,
    rightOffset: '20px',
    topOffset: '20px',
    bottomOffset: '20px',
    handleLinks: 'external-new-tab',
    closeButton: {
      color: 'black',
      size: '20px',
      isRequiredToDismissMessage: false,
      sideOffset: '49%',
      topOffset: '20px',
    },
  };

  const generateJWT = async () => {
    const data = await MarketingApi.generateIterableJwt();
    return data?.jwt || '';
  };

  const persistJwtToken = (token) => {
    const iterablJWT = sessionStorage.getItem('iterable-jwt');
    const iterableTimstamp = sessionStorage.getItem('iterable-jwt-timestamp');

    if (iterablJWT && iterableTimstamp) {
      const daysPassed = ((new Date()) - (new Date(iterableTimstamp))) / (1000 * 3600 * 24);

      if (daysPassed <= 90) return iterablJWT;
      sessionStorage.removeItem('iterable-jwt');
      sessionStorage.removeItem('iterable-jwt-timestamp');
    }

    sessionStorage.setItem('iterable-jwt', token);
    sessionStorage.setItem('iterable-jwt-timestamp', new Date().toISOString());
  };

  useEffect(() => {
    if (!isLoggedIn || !process.env.REACT_APP_ITERABLE_IN_APP_API_KEY) return;

    const { setUserID, logout } = initializeWithConfig({
      authToken: process.env.REACT_APP_ITERABLE_IN_APP_API_KEY,
      configOptions: {
        isEuIterableService: false,
        dangerouslyAllowJsPopups: true,
      },
      generateJWT,
    });
    const { request } = getInAppMessages(inAppProperties, { display: 'immediate' });

    setUserID(id).then((token) => {
      persistJwtToken(token);
      request().then(() => {
        Iterable.setInAppRequest();
        // setTimeout(() => {
        //   const iframe = document.querySelector('#iterable-iframe');
        //   if (iframe) {
        //     iframe.style.maxWidth = '480px';
        //   }
        // }, 1000);
      }).catch();
    // eslint-disable-next-line no-console
    }).catch((error) => { console.error(error); });

    return () => {
      logout();
    };
  }, [isLoggedIn]);
};

export default useInAppMessage;
